import Filter, {FilterTypeEnum} from "../../../model/workspace/Filter";
import {option, Option} from "ts-option";
import * as React from "react";
import FilterButton from "./button/FilterButton";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import FilterButtons from "./FilterButtons";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import _ = require("underscore");

interface IComponentProps {
	filter: Filter;
	onRemove: (refreshData: boolean) => void;
	onChange: (filter: Filter) => void;
	isFilterConfigVisible?: boolean;
	negationDisabled?: boolean;
}

interface IState<T> {
	selectedItems: T[];
	isFilterConfigVisible: boolean;
	isNegated: boolean
}

export interface WorkspaceFilterReduxProps<T> {
	/**
	 * All items.
	 */
	items: Option<T[]>;
}

type IProps<T> = WorkspaceFilterReduxProps<T> & IComponentProps

export default abstract class WorkspaceFilter<T, P = {}> extends React.Component<IProps<T> & P, IState<T>> {

	constructor(props: IProps<T> & P) {
		super(props);
		this.state = {
			selectedItems: this.getItemsFromIds((props.filter.values as Option<string[]>).getOrElse([])),
			isFilterConfigVisible: props.isFilterConfigVisible,
			isNegated: props.filter.isNegated()
		};
		this.onChange = this.onChange.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.onDone = this.onDone.bind(this);
	}

	componentWillReceiveProps(nextProps: IProps<T>) {
		if (this.props.items.isEmpty && nextProps.items.isDefined) {
			this.setState({selectedItems: this.getItemsFromIds((nextProps.filter.values as Option<string[]>).getOrElse([]))})
		}
	}


	render() {
		const isLoading = this.props.items.isEmpty;
		return (
			<div>
				<FilterButton filterName={this.props.filter.columnDefinition.label}
							  onRemove={() => this.props.onRemove(true)}
							  onClick={() => this.setState({isFilterConfigVisible: true})}
							  filterValue={this.getDisplayValue()}
							  isDisabled={this.state.isFilterConfigVisible && !isLoading}
							  isLoading={isLoading}
							  isNegated={this.props.filter.isNegated()}/>
				{!isLoading && this.state.isFilterConfigVisible &&
				this.props.items.map(items =>
					<DropDownWrapper width={"auto"} onOutsideClick={this.onCancel}>
						{this.renderContent(items)}

						<FilterButtons onCancel={this.onCancel} onDone={this.onDone}
									   disabled={!this.state.selectedItems.length}/>
					</DropDownWrapper>).orNull}
			</div>
		)
	}

	getNegationCheckbox(): JSX.Element {
		if (this.props.negationDisabled) {
			return undefined;
		}
		return (
			<div className={"negation-checkbox"}>
				<Checkbox checked={this.state.isNegated}
						  label={"Is not"}
						  styles={{color: "#112363"}}
						  onChange={(value) => this.setState({isNegated: value})}/>
			</div>)
	}

	onCancel() {
		this.setState({
			isFilterConfigVisible: false,
			selectedItems: this.getItemsFromIds((this.props.filter.values as Option<string[]>).getOrElse([]))
		}, () => this.props.filter.values.isEmpty && this.props.onRemove(false));
	}

	onDone() {
		const filterType = this.state.isNegated ? FilterTypeEnum.NotIn : FilterTypeEnum.In;
		this.setState({isFilterConfigVisible: false},
			() => this.isFilterChanged(filterType)
				&& this.props.onChange(
					this.props.filter.copy(
						{values: option(this.state.selectedItems.map(i => this.itemToId(i))), type: filterType}))
		)
	}

	isFilterChanged(filterType: FilterTypeEnum) {
		return !_.isEqual(this.props.filter.values.getOrElse([]), this.state.selectedItems.map(i => this.itemToId(i))) ||
			this.props.filter.type !== filterType
	}

	onChange(items: T[]) {
		this.setState({selectedItems: items})
	}

	getItemsFromIds(itemIds: string[]): T[] {
		return this.props.items.getOrElse([]).filter(i => itemIds.indexOf(this.itemToId(i)) > -1)
	}

	getSelectedItems(): T[] {
		return this.state.selectedItems
	}

	getDisplayValue() {
		return this.getItemsFromIds((this.props.filter.values as Option<string[]>).getOrElse([]))
			.map(i => this.itemToLabel(i)).join(", ")
	}

	abstract itemToId(item: T): string;

	abstract itemToLabel(item: T): string;

	abstract renderContent(items: T[]): JSX.Element
}
